//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import EsQuery from '@/javascript/esQuery'
    import util from '@/javascript/util'
    import loading from '@/components/public-components/loading/index.vue'
    import Swiper from "swiper"
    import goBack from '@/components/public-components/goBack/index.vue'

    export default {
        components: {
            loading,
            goBack
        },
        data() {
            return {
                minHeight: 0,
                guideList: [],
                infiniteAll: false,
                infiniteStatus: false,
                pageSize: 10,
                pageNo: 0,
                swiperList: [],
            }
        },
        filters: {
            showLevel(key) {
                const level = {
                    '102001': '非',
                    '102002': 1,
                    '102003': 2,
                    '102004': 3,
                    '102005': 4,
                    '102006': 5
                }
                return level[key + '']
            }
        },
        methods: {
            getGuideList() {
                const querystring = require('querystring')
                const recommendEsQuery = new EsQuery()
                recommendEsQuery.addString("category", this.XXCJ_TYPE_CODE.LYSFC, recommendEsQuery.and, false)
                    .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, recommendEsQuery.and, false)
                    .addPage(this.pageNo * this.pageSize, this.pageSize)
                    .addSort("weight", recommendEsQuery.desc, false)
                const recommendEsJsonQuery = JSON.stringify(recommendEsQuery.getArray())
                this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
                    'indexName': this.INDEX_NAME_TYPE.scenic,
                    'esJsonQuery': recommendEsJsonQuery
                })).then((response) => {
                    window.addEventListener('scroll', this.windowScroll) // 监听滚动
                    const list = response.data.data
                    list.map(i => {
                        // 临时存储一下图片
                        let temp = i._source.images
                        // 过滤出fileIdentify：titleImage的图片
                        i._source.images = i._source.images.filter(item => {
                            // return item.fileIdentify.includes('titleImage')
                        })
                        // 处理不含有fileIdentify：titleImage图片的问题
                        if (i._source.images.length == 0) {
                            i._source.images = temp
                        }
                        return i
                    })
                    this.guideList = this.guideList && this.guideList.length >= 0 ? this.guideList.concat(list) : this.guideList

                    if (this.guideList.length < this.pageNo * this.pageSize) {
                        this.infiniteAll = true
                    }
                    this.infiniteStatus = false
                })
            },
            windowScroll(e) {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                if (scrollTop > 0) {
                    this.isShow = true
                } else {
                    this.isShow = false
                }
                // 底部加载
                if (util.pullUpLoad()) {
                    this.infinite()
                }
            },
            infinite() {
                if (this.infiniteAll) {
                    return
                }
                if (this.infiniteStatus) {
                    return
                }
                this.pageNo += 1
                this.getGuideList()
            },
            getSwiperData() {
                const querystring = require('querystring')
                const swiperEsQuery = new EsQuery()
                swiperEsQuery.addString("category", this.XXCJ_TYPE_CODE.LYSFC, swiperEsQuery.and, false)
                    .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, swiperEsQuery.and, false)
                    .addPage(this.pageNo * this.pageSize, this.pageSize)
                    .addSort("weight", swiperEsQuery.desc, false)
                    .addString('tags', '乡村推荐', swiperEsQuery.and, false)
                const swiperEsJsonQuery = JSON.stringify(swiperEsQuery.getArray())
                this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
                    'indexName': this.INDEX_NAME_TYPE.scenic,
                    'esJsonQuery': swiperEsJsonQuery
                })).then((response) => {
                    const list = response.data.data
                    list.map(i => {
                        // 临时存储一下图片
                        let temp = i._source.images
                        // 过滤出fileIdentify：titleImage的图片
                        i._source.images = i._source.images.filter(item => {
                            // return item.fileIdentify.includes('titleImage')
                        })
                        // 处理不含有fileIdentify：titleImage图片的问题
                        if (i._source.images.length == 0) {
                            i._source.images = temp
                        }
                        return i
                    })
                    this.$set(this, 'swiperList', list)
                    this.$nextTick(() => {
                        new Swiper(".scenic-swiper", {
                            slidesPerView: "auto",
                            centeredSlides: true,
                            spaceBetween: 15,
                            loop: true,
                        })
                    })
                })
            }
        },
        mounted() {
            document.title = '美丽乡村'
            this.minHeight = document.documentElement.clientHeight - this.$refs.top.offsetHeight
            this.getSwiperData()
            // 获取列表
            this.getGuideList()
        },
    }
